import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'
import { integrationsClient } from '../../../apollo/api'

const MUTATION = gql`
  mutation RemoveIntegrations($ids: [Int]) {
    removeIntegrations(ids: $ids)
  }
`
// TODO - teste delete
export const useRemoveIntegrations = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Integrations', 'IntegrationsCount'],
    client: integrationsClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
